import React, { createContext, useContext } from 'react';

/**
 * Shell context to communicate layout nesting depth.
 * This allows PageContainer to behave polymorphically:
 * - Inside a shell: render as a pass-through title-sync component.
 * - Outside a shell: render as a full desktop-first layout driver.
 */
interface LayoutShellContextType {
    inShell: boolean;
}

const LayoutShellContext = createContext<LayoutShellContextType>({
    inShell: false,
});

export const LayoutShellProvider: React.FC<{
    inShell: boolean;
    children: React.ReactNode;
}> = ({ inShell, children }) => {
    return (
        <LayoutShellContext.Provider value={{ inShell }}>
            {children}
        </LayoutShellContext.Provider>
    );
};

export const useLayoutShell = () => useContext(LayoutShellContext);
